import { Spinner } from '@blueprintjs/core';

import WorkOrders from '../components/WorkOrders';
import { useFeatureFlagEnabledForNewWorkOrderPage } from '../hooks/useVariant';
import NotFoundErrorPage from './NotFoundErrorPage';

const WorkOrderIndex: React.FC = () => {
  const { isEnabled, isLoading } = useFeatureFlagEnabledForNewWorkOrderPage();

  if (isLoading) {
    return <Spinner />;
  }

  if (!isEnabled && !isLoading) {
    return <NotFoundErrorPage />;
  }

  return <WorkOrders />;
};

export default WorkOrderIndex;
